/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-23 23:11:56
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-05-06 18:25:19
 * @FilePath: /seller-station-client/src/hooks/useInitGetUserInfo.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { userInfo } from '@/atom/user';
import { isLogin, isVip } from '@/atom/mall/user';

/** 获取用户信息 */
const useInitGetUserInfo = () => {
	const setIsLogin = useSetAtom(isLogin);
	const setIsVip = useSetAtom(isVip);
	const user = userInfo();

	useEffect(() => {
		setIsVip((user?.membership?.templateLevel ?? 0) > 0);
		setIsLogin(!!user?.customerId);
	}, [user, setIsVip, setIsLogin]);
};

export default useInitGetUserInfo;
